import Grid from '@mui/material/Grid'
import Backspace from '@mui/icons-material/Backspace'
import Clear from '@mui/icons-material/Clear'
import NumberButton from './components/NumberButton'
import SignButton from './components/SignButton'
import { useImperativeHandle } from 'react'
import useKeyInputPIN from 'hooks/useKeyInputPIN/useKeyInputPIN'
interface NumpadInputProps {
    onClickNumpad: (number: string) => void
    activeNumber?: string
}

const NumpadInput = ({ onClickNumpad, activeNumber }: NumpadInputProps) => {
    let cols: any[] = []
    for (let i = 0; i < 3; i++) {
        let rows: any[] = []
        for (let j = 1; j < 4; j++) {
            rows.push(
                <Grid item key={`${i}${j}`}>
                    <NumberButton
                        onClick={onClickNumpad}
                        number={(i * 3 + j).toString()}
                        isActive={activeNumber === (i * 3 + j).toString()}
                    />
                </Grid>,
            )
        }
        cols.push(
            <Grid
                item
                spacing={2}
                container
                justifyContent="center"
                direction="row"
                alignItems="center"
                key={i}
            >
                {[...rows]}
            </Grid>,
        )
    }
    return <>{cols}</>
}

export function NumpadCircleInput(props: {
    onClickNumpad: (a: string) => void
    onClickClear: () => void
    onClickBack: () => void
    onPressEnter?: () => void
    iconSize?: string | number | undefined
    useKeyboard?: boolean
}) {
    const { keyInputRef } = useKeyInputPIN(props.useKeyboard ?? false)

    // Set PIN Keyboard Input Handler
    useImperativeHandle(keyInputRef, () => ({
        onNumberKeyPress: (key: string) => {
            props.onClickNumpad(key)
        },
        onBackspacePress: () => {
            props.onClickBack()
        },
        onEnterPress: () => {
            props.onPressEnter?.()
        },
    }))

    return (
        <Grid
            spacing={2}
            container
            justifyContent="center"
            direction="column"
            alignItems="center"
        >
            <Grid container item spacing={1}>
                <NumpadInput onClickNumpad={props.onClickNumpad} />
            </Grid>

            <Grid
                item
                spacing={2}
                container
                justifyContent="center"
                direction="row"
                alignItems="center"
            >
                <Grid item>
                    <SignButton
                        onClick={props.onClickClear}
                        icon={
                            <Clear
                                style={{
                                    width: props.iconSize,
                                    height: props.iconSize,
                                }}
                            ></Clear>
                        }
                        label="Clear"
                    />
                </Grid>
                <Grid item>
                    <NumberButton onClick={props.onClickNumpad} number="0" />
                </Grid>
                <Grid item>
                    <SignButton
                        onClick={props.onClickBack}
                        icon={
                            <Backspace
                                style={{
                                    width: props.iconSize,
                                    height: props.iconSize,
                                }}
                            ></Backspace>
                        }
                        label="Back"
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}
